// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function* safe(effect) {
    try {
        return { result: yield effect, error: null };
    } catch (error) {
        return { result: null, error };
    }
}
